
import React from 'react';
import Layout from '@/components/Layout/Layout';
import SalaryCalculator from '@/components/SpecialCalculators/FinancialCalculators/SalaryCalculator';
import { Link } from 'react-router-dom';

const SalaryCalculatorPage = () => {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4">
        {/* Header Section */}
        <div className="mb-8">
          <div className="text-sm text-gray-500 mb-2">
            <Link to="/" className="hover:underline">Home</Link> {' > '} 
            <Link to="/special" className="hover:underline">Special Tools</Link> {' > '} 
            <span>Salary Calculator</span>
          </div>
          <h1 className="text-3xl font-bold mb-3">Salary Calculator</h1>
          <p className="text-gray-700">
            Convert between hourly and annual wages, compare salary offers, and understand the impact of raises or job changes.
          </p>
        </div>

        {/* Calculator Section */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 mb-8">
          <SalaryCalculator />
        </div>

        {/* Information Section */}
        <div className="bg-[#E6F3FF] p-6 rounded-lg mb-8">
          <h2 className="text-2xl font-semibold mb-3">How to use the Salary Calculator</h2>
          <ol className="list-decimal list-inside space-y-2 text-gray-700 ml-2">
            <li>Choose the calculation you want to perform (annual to hourly, hourly to annual, or salary comparison)</li>
            <li>Enter the required values for your selected calculation</li>
            <li>Review the results to make informed decisions about your compensation</li>
          </ol>
        </div>

        {/* Additional Information */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">About Salary Calculations</h2>
          <p className="text-gray-700 mb-3">
            Converting between hourly wages and annual salary helps you understand your compensation structure and make 
            meaningful comparisons between different job offers or work arrangements.
          </p>
          <p className="text-gray-700 mb-3">
            A standard full-time work year is typically calculated as 2,080 hours (40 hours per week × 52 weeks). However, 
            this calculator allows you to customize the hours worked per week and weeks worked per year to account for 
            part-time work, extended vacations, or other variations from the standard work year.
          </p>
          <p className="text-gray-700 mb-3">
            When evaluating a salary increase, it's important to consider both the dollar amount and the percentage increase. 
            A percentage increase gives you a better understanding of the relative improvement in your compensation compared 
            to your previous salary.
          </p>
        </div>

        {/* Related Calculators */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">Related Calculators</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <Link to="/special/tax" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">📊</span> Tax Calculator
            </Link>
            <Link to="/special/retirement" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">👴</span> Retirement Calculator
            </Link>
            <Link to="/special/loan" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">💰</span> Loan Calculator
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SalaryCalculatorPage;
